import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';

export interface TextFormFieldProps extends React.ComponentProps<typeof TextField> {
  showClearButton?: boolean;
  onClear?: () => void;
}

export const TextFormField = ({
  disabled,
  showClearButton,
  onClear,
  ...props
}: TextFormFieldProps) => {
  return (
    <TextField
      sx={{
        width: '100%',
        '& .MuiOutlinedInput-notchedOutline': {
          border: '2px solid #B4BCC2'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: '2px solid #697885'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '2px solid #697885'
        },
        '&:focus-within .MuiOutlinedInput-notchedOutline': {
          border: '2px solid #697885'
        },
        '& .MuiInputBase-input::placeholder': {
          fontSize: '16px',
          color: '#1F2428',
          fontWeight: '400',
          lineHeight: '24px'
        },
        '& .MuiInputBase-input': {
          fontSize: '16px',
          color: '#1F2428',
          fontWeight: '400',
          lineHeight: '24px'
        },
        '& .MuiFormHelperText-root': {
          marginLeft: 0
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: '#DA291C'
        },
        '& .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#DA291C'
        },
        '& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#DA291C'
        },
        '& .MuiOutlinedInput-root': {
          '&.Mui-disabled': {
            backgroundColor: '#f0f2f3',
            '& fieldset': {
              border: 'none'
            },
            '& input': {
              color: '#1f2428',
              WebkitTextFillColor: 'unset'
            }
          }
        }
      }}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <Box display="flex" flexDirection="row" gap="16px">
                {showClearButton && !disabled && (
                  <>
                    <IconButton aria-label="clear search button" onClick={onClear}>
                      <CmhcIcon type="icon_clear_circle" size={CmhcIconSize.SMALL} />
                    </IconButton>
                  </>
                )}
              </Box>
            </InputAdornment>
          )
        }
      }}
      disabled={disabled}
      {...props}
    />
  );
};
